import React from 'react'

import { EmptyState } from 'components/empty-state/EmptyState'
import { MAX_RENDERABLE_DATAPOINTS } from 'features/charts-v2/constants'

/**
 * Shared empty-state shown by the chart canvas, legend, and data table when the
 * rendered row count (distinct primary-breakdown values, see
 * `utils/parent-row-count.ts`) exceeds MAX_RENDERABLE_DATAPOINTS. All three
 * surfaces must show this identical message so the user sees a consistent
 * "too many datapoints" experience rather than a partial crash.
 */
export const TooManyDatapointsState: React.FC<{ textWidth?: string }> = ({
  textWidth = '300px',
}) => (
  <EmptyState
    title="Too many datapoints"
    description={`Can only display ${MAX_RENDERABLE_DATAPOINTS.toLocaleString()} datapoints at a time. Add filters to view your chart`}
    fullHeight="container"
    textWidth={textWidth}
  />
)
